module.exports = __webpack_public_path__ + "static/media/eye.84b2cf68.svg";